package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TimePicker
import androidx.compose.material3.TimePickerColors
import androidx.compose.material3.TimePickerDefaults
import androidx.compose.material3.rememberTimePickerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.ui.theme.LocalTheme.p54
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.compose.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
actual fun TimePickerField(
    modifier: Modifier,
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    enabled: Boolean,
    isError: Boolean,
    errorText: String
) {
    var showTimePicker by remember { mutableStateOf(false) }

    val (initialHour, initialMinute) = parseTimeHHmm(value) ?: (17 to 0)
    val timePickerState = rememberTimePickerState(
        initialHour = initialHour,
        initialMinute = initialMinute,
        is24Hour = true
    )

    Box(modifier = modifier) {
        DefaultCircleShapedTextField(
            modifier = Modifier.fillMaxWidth(),
            value = value,
            onValueChange = {},
            label = label.ifBlank { null },
            enabled = enabled,
            readOnly = true,
            canFocus = false,
            isError = isError,
            errorText = errorText
        )

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .heightIn(min = p54)
                .clickable(enabled = enabled) {
                    showTimePicker = true
                }
        )
    }

    if (showTimePicker) {
        val c = AppTheme.current.colors
        val timePickerColors = TimePickerColors(
            clockDialColor = c.surfaceContainer,
            selectorColor = c.primary,
            containerColor = c.surface,
            periodSelectorBorderColor = c.outline,
            clockDialSelectedContentColor = c.onPrimary,
            clockDialUnselectedContentColor = c.onSurface,
            periodSelectorSelectedContainerColor = c.primaryContainer,
            periodSelectorUnselectedContainerColor = c.surfaceContainer,
            periodSelectorSelectedContentColor = c.primary,
            periodSelectorUnselectedContentColor = c.onSurface,
            timeSelectorSelectedContainerColor = c.primaryContainer,
            timeSelectorUnselectedContainerColor = c.surfaceContainer,
            timeSelectorSelectedContentColor = c.primary,
            timeSelectorUnselectedContentColor = c.onSurface
        )
        AlertDialog(
            onDismissRequest = { showTimePicker = false },
            containerColor = c.surface,
            confirmButton = {
                TextButton(
                    onClick = {
                        onValueChange(formatTimeHHmm(timePickerState.hour, timePickerState.minute))
                        showTimePicker = false
                    }
                ) {
                    Text(stringResource(SR.strings.ok), color = c.primary)
                }
            },
            dismissButton = {
                TextButton(onClick = { showTimePicker = false }) {
                    Text(stringResource(SR.strings.cancel), color = c.primary)
                }
            },
            title = { if (label.isNotBlank()) Text(label, color = c.onSurface) },
            text = {
                TimePicker(
                    state = timePickerState,
                    colors = timePickerColors
                )
            }
        )
    }
}
